import React from "react";
import { BookOpenIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import { NVR_OPTIONS } from "@/constants/constants";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
} from "@tracify/ui/select";
import { useNewVsReturningState, type NvrType } from "@/lib/hooks/url-state";

const NvrDropdown: React.FC = () => {
  const { newVsReturning, setNewVsReturning } = useNewVsReturningState();

  return (
    <Select
      value={newVsReturning}
      onValueChange={(val: NvrType) => setNewVsReturning(val)}
    >
      <SelectTrigger id="nvr-select-trigger">
        <span className="truncate font-semibold mr-2 inline-flex items-center">
          <UserGroupIcon className="h-4 w-4 inline-block mr-2" />{" "}
          {(() => {
            const label =
              NVR_OPTIONS.find((el) => el.value === newVsReturning)?.label ??
              "All Customers";
            return (
              <>
                <span className="md:hidden">
                  {label.replace(" Customers", "")}
                </span>
                <span className="hidden md:inline">{label}</span>
              </>
            );
          })()}
        </span>
      </SelectTrigger>
      <SelectContent className="relative max-w-[270px]">
        <SelectGroup className="space-y-1">
          {NVR_OPTIONS.map((option, index) => (
            <React.Fragment key={option.value}>
              <SelectItem
                value={option.value}
                data-testid={`nvr-select-item-${option.value}`}
              >
                <div className="text-sm font-medium leading-tight">
                  {option.title}
                </div>
                <div className="mt-1 text-xs font-normal leading-none">
                  {option.description}
                </div>
              </SelectItem>
            </React.Fragment>
          ))}
        </SelectGroup>
        <SelectGroup>
          <SelectSeparator />
          <SelectLabel className="py-3 -m-1 font-normal rounded-t-none bg-accent text-accent-foreground flex items-center">
            <BookOpenIcon className="h-4 w-4" />
            <a
              href="https://knowledge.tracify.ai/en/articles/32101-what-is-user-segmentation-new-vs-returning-users-customers"
              className="underline ml-1 text-xs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more about customer segmentation
            </a>
          </SelectLabel>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default NvrDropdown;
